import React, { useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';

import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Tooltip,
} from '@mui/material';

import { AspectRatio } from '@mui/icons-material'

// === COMPONENTS ===
import { ImageCanvas } from './Canvas';
import { toBoolean } from 'components/utils';

// === CSS ===
import './image.css';

function Image( props ) {

  //#region [VALUES] === STATE

  const theme = useTheme();

  const [ is_full_size      , setIsFullSize      ] = useState( false );
  const [ is_magnifier_held , setIsMagnifierHeld ] = useState( true  );
  const [ magnifier_size    , setMagnifierSize   ] = useState( 100   );

  let is_magnifier_held_default = toBoolean( localStorage.getItem( 'image-magnifier-hold' ) );

  const settings = {
    is_full_size,
    is_magnifier_held,
    magnifier_size,
  }
    
  //#endregion

  //#region [STYLES]
  
  const _styles = {
    container: {
      gridColumn : 'span 6'   ,
      position   : 'relative' ,
      overflow   : 'hidden'     ,
      width  : '100%',
      height : '100%',
    },
    container_image: {
      position   : 'relative' ,
      overflow   : 'auto'     ,
      width  : '100%',
      height : 'calc( 100% - 5rem )',
    },
    control_box: {
      position   : 'relative',
      margin     : '0.5rem',
      display    : 'flex',
      height     : '4rem',
      opacity    : '1',
      transition : 'opacity 0.8s ease',
      zIndex     : 30,
    },
    image_paper: {
      gridColumn : 'span 6'   ,
      overflow   : 'auto'     ,
      width      : '100%'     ,
      position   : 'relative' ,
      height     : '100%'     ,
    }
  }

  const CONTAINER = {
    style: _styles.container,
  }

  const CONTAINER_IMAGE = {
    style: _styles.container_image,
  }

  const CONTROL_BOX = {
    style: _styles.control_box,
  }
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [METHOD]

  //-----------------------------------------------------------------
  function popup() {
    //-----------------------------------------------------------------

    window.open('https://localhost:3000/prokeyweb/', 'test', 'popup')
  }

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function toggleImageSize() {
    //-----------------------------------------------------------------
    setIsFullSize ((prev) => !prev)
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierHeld( event ) {
    //-----------------------------------------------------------------
    setIsMagnifierHeld(event.target.checked)
    localStorage.setItem('image-magnifier-hold', event.target.checked);
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierSize( event ) {
    //-----------------------------------------------------------------
    const number = Number(event.target.value);
    if (0 <= number && number <= 999) {
      setMagnifierSize( number );
    }
  }

  //#endregion 

  //#region [RENDER]
  
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <div { ...CONTROL_BOX } >
          <div style={{ width: '100%'}} />
          <Tooltip title={is_full_size ? 'Fit' : 'Full Size'}>
            <IconButton size='large' onClick={toggleImageSize} color='primary'>
              {is_full_size ? <AspectRatio fontSize="large" /> : <AspectRatio fontSize="large" />}
            </IconButton>
          </Tooltip>
          <div style={{ width: '2rem'}} />
          <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 2, borderColor: theme.palette.primary[theme.palette.mode] }} />
          <div style={{ width: '4rem'}} />
          <div style={{ width: '100%', display: 'flex', justifyContent:'center', alignItems: 'center'}}>
            Magnifier:
            <div style={{ width: '1rem'}} />

            <FormControl sx={{ m: 1, width: '6rem' }} variant="outlined">
              <InputLabel htmlFor="magnifier-size-input">Size</InputLabel>
              <OutlinedInput
                id="magnifier-size-input"
                value={magnifier_size}
                size='small'
                label='Size'
                onChange={onChange_MagnifierSize}
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
              />
            </FormControl>
            <div style={{ width: '1rem'}} />
            <FormControlLabel
              label   = "Hold"
              control ={<Checkbox defaultChecked={is_magnifier_held_default} onChange={onChange_MagnifierHeld}/>}
            />
          </div>
          <div style={{ width: '100%'}} />
        </div>
        <div { ...CONTAINER_IMAGE } >
          <ImageCanvas settings={settings} />
        </div>
      </div>
    )
  }

  //#endregion
  
  return display();
}

export {Image};